import React, { useEffect, useRef } from 'react';

export interface ContextCircularItem {
  icon: React.ReactNode;
  onClick: () => void;
  label: string;
}

export const ContextCircularMenu: React.FC<{
  items: ContextCircularItem[];
}> = ({ items }) => {
  const circleRef = useRef<HTMLDivElement>(null);

  // Position the items around the circle
  useEffect(() => {
    const circle = circleRef.current!;
    const links = Array.from(
      circle.querySelectorAll<HTMLDivElement>('.context-item')
    );
    const total = links.length;
    links.forEach((link, i) => {
      const angle = -0.5 * Math.PI - 2 * (1 / total) * i * Math.PI;
      const x = 50 + 40 * Math.cos(angle); // 40% out
      const y = 50 + 40 * Math.sin(angle);
      link.style.left = `${x}%`;
      link.style.top = `${y}%`;
    });

    // auto‐close on any click outside
    const onBodyClick = (e: MouseEvent) => {
      e.stopPropagation();
      // leafet popup will close automatically if you call map.closePopup()
    };
    document.body.addEventListener('click', onBodyClick);
    return () => document.body.removeEventListener('click', onBodyClick);
  }, [items]);

  return (
    <div className="context-circular-menu">
      <div className="circle open" ref={circleRef}>
        {items.map((it, idx) => (
          <div key={idx} className="context-item">
            <div className="smart-map-context-menu-content">
              <div className="smart-map-context-menu-icon">{it.icon}</div>
              <div className="smart-map-context-menu-label">{it.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
